// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__19UNX","body":"style_body__22nCw"};